import { Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-sub-section-header',
    templateUrl: './sub-section-header.component.html',
    styleUrls: ['./sub-section-header.component.scss']
})
export class SubSectionHeaderComponent {
    @Input() text = '';
}
